import { memo } from 'react';
import Icon from '@dtvgo/icon';
import './Button.scss';
import { jsxs, jsx } from 'react/jsx-runtime';

/* External */
function Button(_ref) {
  var type = _ref.type,
    children = _ref.children,
    onClick = _ref.onClick,
    onMouseDown = _ref.onMouseDown,
    onMouseEnter = _ref.onMouseEnter,
    primary = _ref.primary,
    secondGray = _ref.secondGray,
    secondBlue = _ref.secondBlue,
    className = _ref.className,
    disabled = _ref.disabled,
    bordered = _ref.bordered,
    icon = _ref.icon;
  return /*#__PURE__*/jsxs("button", {
    // eslint-disable-next-line react/button-has-type
    type: type,
    disabled: disabled,
    onClick: onClick,
    onMouseDown: onMouseDown,
    onMouseEnter: onMouseEnter,
    className: "dtv-common-c-button ".concat(primary ? 'dtv-common-c-button--primary' : '', " ").concat(secondGray ? 'dtv-common-c-button--second-gray' : '', " ").concat(secondBlue ? 'dtv-common-c-button--second-blue' : '', " ").concat(disabled ? 'dtv-common-c-button--disabled' : '', " ").concat(bordered ? 'dtv-common-c-button--bordered' : '', " ").concat(icon ? 'dtv-common-c-button--with-icon' : '', " ").concat(className),
    children: [children, icon && /*#__PURE__*/jsx(Icon, {
      className: "dtv-common-c-button__icon",
      name: icon
    })]
  });
}
Button.defaultProps = {
  children: [],
  type: 'button',
  onClick: undefined,
  onMouseDown: undefined,
  onMouseEnter: undefined,
  primary: false,
  secondGray: false,
  secondBlue: false,
  className: '',
  disabled: false,
  bordered: false,
  icon: ''
};
var Button$1 = /*#__PURE__*/memo(Button);

export { Button$1 as default };
//# sourceMappingURL=Button.js.map
